import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { root } from "./styles";

export const Error404 = (props: any): any => {
  const { t } = useTranslation();

  return (
    <Box sx={root}>
      <Typography variant="h1">{t("error.notFoundCode").valueOf()}</Typography>
      <Typography variant="h3">{t("error.notFoundTitle").valueOf()}</Typography>
      <Typography variant="body1">
        {t("error.notFoundDescription").valueOf()}
      </Typography>
    </Box>
  );
};

export default Error404;
